import React from 'react';
import PageContainer from 'common/components/PageContainer';
import {AppraisalsProvider} from "../../contexts/AppraisalsContext";
import AppraisalsTable from "../AppraisalsTable";

const AppraisalsPage = () => {

  return (
    <AppraisalsProvider>
      <PageContainer>
        <AppraisalsTable/>
      </PageContainer>
    </AppraisalsProvider>
  );
};

export default AppraisalsPage;